module.exports = __webpack_public_path__ + "static/img/IMG_20170719_234723.51d52bc0.jpg";